export default __webpack_public_path__ + "static/media/main-mobile.83207c25.png";